import { Styles } from '@types'
import { Select, Input, Tag } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import { Services } from 'gadjet-v2-types/dist/model'
import { ServiceSaleSearch } from 'gadjet-v2-types/dist/type/search'
import { RangeValue } from 'rc-picker/lib/interface'
import { useEffect, useMemo } from 'react'

import LocalDatePicker from '@components/atoms/LocalDatePicker'
import SearchBox from '@components/molecules/SearchBox'
import SearchItem from '@components/molecules/SearchItem'

type Props = {
  search: ServiceSaleSearch
  service: { list: Services[]; loading: boolean }
  onChangeSearch: (search: Partial<ServiceSaleSearch>) => void
  onSearch: () => void
  branchId: number
}

export default function BranchServiceSaleSearchBox({
  search,
  service,
  onChangeSearch,
  onSearch,
  branchId,
}: Props): JSX.Element {
  const onChangeQuery = (e: React.ChangeEvent<HTMLInputElement>) => onChangeSearch({ query: e.target.value })
  const onChangeServices = (_serviceIds: number[]) => onChangeSearch({ serviceIds: _serviceIds })

  const onChangeDateRange = (_value: RangeValue<Dayjs>) => {
    const start = _value?.[0]?.format('YYYY-MM-DD') || search.datetime[0]
    const end = _value?.[1]?.format('YYYY-MM-DD') || search.datetime[1]
    onChangeSearch({ datetime: [start, end] })
  }

  const rangeValue = useMemo((): [Dayjs, Dayjs] => {
    const [start, end] = search.datetime
    return [dayjs(start), dayjs(end)]
  }, [search])

  useEffect(() => {
    onChangeServices([])
  }, [branchId])

  return (
    <SearchBox onSearch={onSearch}>
      <SearchItem label="서비스" span={9}>
        <Select
          loading={service.loading}
          mode="multiple"
          onChange={onChangeServices}
          size="large"
          value={search.serviceIds}
          style={styles.select}
          tagRender={({ label }) => <Tag>{label}</Tag>}
        >
          {service.list.map((s) => (
            <Select.Option key={s.serviceId} value={s.serviceId}>
              {s.name}
            </Select.Option>
          ))}
        </Select>
      </SearchItem>
      <SearchItem label="날짜" span={6}>
        <LocalDatePicker.RangePicker
          size="large"
          style={styles.datePicker}
          value={rangeValue}
          onChange={onChangeDateRange}
        />
      </SearchItem>

      <SearchItem label="검색어" span={6}>
        <Input size="large" placeholder="검색어를 입력하세요." value={search.query} onChange={onChangeQuery} />
      </SearchItem>
    </SearchBox>
  )
}

const styles: Styles = {
  datePicker: { width: '100%' },
  select: { width: '100%' },
}
